import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoaderService } from '../../../../infrastructure/services/loader.service';
import { HistorialService, Historial } from '../../../../infrastructure/services/historial.service';
import 'rxjs/add/operator/share';
import { Subscription } from 'rxjs/Subscription';
import { SxfDesignerService } from '../../services/sxfdesigner-service';

@Component({
  templateUrl: './designer.historial.component.html',
})
export class DesignerHistorialComponent implements OnInit, OnDestroy {
  historial: Historial[];
  selected: Historial;
  codForm: string;
  textoIzquierda = '';
  textoDerecha = '';
  subscription: Subscription;

  constructor(private aRoute: ActivatedRoute,
              public loader: LoaderService,
              private historialService: HistorialService,
              private productService: SxfDesignerService,
              private router: Router) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codForm = params['codForm'];
      this.subscription = this.historialService.getHistorial('FormularioDinamico', this.codForm)
        .subscribe(historial => this.historial = historial);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  seleccionar(index) {
    this.textoIzquierda = '';

    if (index < this.historial.length - 1) {
      this.textoIzquierda = this.historial[index + 1].data.Layout;
    }

    this.textoDerecha = this.historial[index].data.Layout;
    this.selected = this.historial[index];
  }

  volverAVersion() {
    this.productService
      .cambiarAVersion(this.codForm, this.selected.id)
      .then(res => this.router.navigate(['../../', ], { relativeTo: this.aRoute }));
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/historial/designer.historial.component.ts